
import http from "../../shared/integrationsApi"

const integrations = {
    state: {
        items: [],
        available: false
    },
    actions: {
        fetchSatellites({commit, state}) {
            return new Promise((resolve, reject) => {
                if (state.items.length > 0) {
                    resolve(state.items)
                    return
                }

                http.get("satellites")
                .then((resp) => {
                    if (resp) {
                        commit('SET_AVAILABILITY', true)
                        commit('SET_SATELLITES', resp.data)
                    } else {
                        commit('SET_AVAILABILITY', false)
                    }

                }).catch((err) => {
                    commit('SET_AVAILABILITY', false)
                    reject(err)
                })
            })
        },

        fetchSatellite({commit, state}, payload) {
            return new Promise((resolve, reject) => {
                http.get("satellite/" + payload.id)
                .then((resp) => {
                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        fetchSatellitesExplore({commit}) {
            return new Promise((resolve, reject) => {
                http.get("satellites/explore")
                .then((resp) => {
                    if (resp) {
                        commit('SET_AVAILABILITY', true)
                        resolve(resp.data.filter(d => {
                            return !d.disabled
                        }))
                    } else {
                        commit('SET_AVAILABILITY', false)
                    }
                }).catch((err) => {
                    commit('SET_AVAILABILITY', false)
                    reject(err)
                })
            })
        },

        // installSatellite({commit}, integration) {
        //     return new Promise((resolve, reject) => {
        //         http.post("integrate", integration.setup).then(resp => {
        //             commit("ADD_SATELLITE", resp.data)
        //             resolve(resp.data)
        //         }).catch(err => {
        //             reject(err)
        //         })
        //     })
        // },

        // uninstallSatellite({commit}, integration) {
        //     return new Promise((resolve, reject) => {
        //         http.put("integrate", integration.setup).then(resp => {
        //             commit("REMOVE_SATELLITE", integration.setup)
        //             resolve(integration.setup)
        //         }).catch(err => {
        //             reject(err)
        //         })
        //     });
        // }
        
    },
    mutations: {
        SET_SATELLITES (state, ints) {   
            state.items = ints || []
        },

        SET_SATELLITE (state, int) {   
            let items = state.items || []
            items.push(int)
        },

        SET_AVAILABILITY (state, available) {
            state.available = available
        },

        ADD_SATELLITE (state, int) {
            state.items.push(int)
        },

        REMOVE_SATELLITE (state, int) {
            state.items = state.items.filter(i => {
                return i.id != int.id
            })
        }
    },
    getters: {
        getSatellites(state) {
            return state.items || []
        },

        getSatellite: (state) => (id) => {
            return state.items.find(i => {
                return i.id == id
            })
        },

        satellitesAvailable(state) {
            return state.available
        }
    }
  }

export default integrations